<template>
  <div>
    <el-row>
      <el-col>
        <el-button size="medium" @click="matchProduct" style="margin-top:20px">匹配档口</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData" style="margin-top:20px">
          <el-table-column label="序号" type="index" width="50px"></el-table-column>
          <el-table-column label="档口名称" prop="DK_NAME"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="deleteProduct(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination :current-page.sync="currentPage" :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totalCount"
          @current-change="handleCurrentChange">
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { queryGroupDetailFun, deteleGroupFun } from 'api/systemSetting';

export default {
  data() {
    return {
      tableData: [],
      kindsId: sessionStorage.getItem('kindId'),
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
    };
  },
  methods: {
    addProduct() {
      this.$router.push({ name: 'addNewProduct' });
      sessionStorage.setItem('kindId', this.kindsId);
    },
    matchProduct() {
      this.$router.push({ name: 'matchDK' });
    },
    // ---------------------------进入页面拉取数据
    queryTable() {
      const params = {
        GROUP_ID: Number(this.kindsId),
      };
      queryGroupDetailFun(params).then((result) => {
        if (result[0]) {
          this.tableData = result;
        } else {
          this.tableData = [];
          this.totalCount = 0;
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ------------------------------删除数据
    deleteProduct(row) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            RELATION_ID: row.RELATION_ID,
          };
          deteleGroupFun(params).then((result) => {
            this.$message.show({ text: '删除成功', type: 'success' });
            this.queryTable();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    handleCurrentChange() {
      this.queryTable();
    },
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.searchForm = this.SAVE_DSORDER_LIST.CONDITION;
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryTable();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/systemSetting/matchGroup.vue